import { render, staticRenderFns } from "./CodeMirror.vue?vue&type=template&id=196e05d6&"
import script from "./CodeMirror.vue?vue&type=script&lang=js&"
export * from "./CodeMirror.vue?vue&type=script&lang=js&"
import style0 from "./CodeMirror.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports